import { render, staticRenderFns } from "./BaseTextarea.vue?vue&type=template&id=6baeb2b0"
import script from "./BaseTextarea.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTextarea.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports